import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=ce7dc324&"
import script from "./Administration.ts?vue&type=script&lang=js&"
export * from "./Administration.ts?vue&type=script&lang=js&"
import style0 from "./Administration.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports